<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "magic-cookie-view__inner" };
import { inject } from "vue";
import { AutoSize } from "@maas/vue-autosize";
import { useCookieState } from "../composables/private/useCookieState";
import { useCookieCallback } from "../composables/private/useCookieCallback";
import { MagicCookieInstanceId } from "../symbols";
import "@maas/vue-equipment/utils/css/animations/fade-in.css";
import "@maas/vue-equipment/utils/css/animations/auto-size-out.css";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicCookieView",
  setup(__props) {
    const instanceId = inject(MagicCookieInstanceId, void 0);
    if (!instanceId) {
      throw new Error(
        "MagicCookiePreferences must be used within a MagicCookieProvider"
      );
    }
    const { initializeState } = useCookieState(instanceId);
    const state = initializeState();
    const {
      onBeforeEnter,
      onEnter,
      onAfterEnter,
      onBeforeLeave,
      onLeave,
      onAfterLeave
    } = useCookieCallback(instanceId);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(
        "div",
        {
          class: "magic-cookie-view",
          style: _normalizeStyle({ "--mc-duration": `${_unref(state).options.animation?.duration}ms` })
        },
        [
          _createVNode(_unref(AutoSize), { width: false }, {
            default: _withCtx(() => [
              _createVNode(_Transition, {
                name: _unref(state).options.transition,
                onBeforeLeave: _unref(onBeforeLeave),
                onLeave: _unref(onLeave),
                onAfterLeave: _unref(onAfterLeave),
                onBeforeEnter: _unref(onBeforeEnter),
                onEnter: _unref(onEnter),
                onAfterEnter: _unref(onAfterEnter),
                persisted: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode(
                    "div",
                    _hoisted_1,
                    [
                      _renderSlot(_ctx.$slots, "default", {
                        viewActive: _unref(state).viewActive
                      })
                    ],
                    512
                    /* NEED_PATCH */
                  ), [
                    [_vShow, _unref(state).viewActive]
                  ])
                ]),
                _: 3
                /* FORWARDED */
              }, 8, ["name", "onBeforeLeave", "onLeave", "onAfterLeave", "onBeforeEnter", "onEnter", "onAfterEnter"])
            ]),
            _: 3
            /* FORWARDED */
          })
        ],
        4
        /* STYLE */
      );
    };
  }
});
</script>

<style>
.magic-cookie-view {
  width: 100%;
  clip-path: var(--magic-cookie-view-clip-path, inset(0));
}

.magic-cookie-view-enter-active {
  position: relative;
  animation: fade-in var(--mc-duration) var(--ease-in-out);
}

.magic-cookie-view-leave-active {
  animation: auto-size-out var(--mc-duration) var(--ease-in-out);
}
</style>
